function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import MaterialButton from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';

var styles = function styles(theme) {
  return {
    root: {
      boxShadow: 'none',
      '&:active': {
        boxShadow: 'none'
      },
      '&:hover': {
        boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 10%), 0px 4px 5px 0px rgb(0 0 0 / 5%), 0px 1px 10px 0px rgb(0 0 0 / 5%)'
      }
    },
    prominent: {
      paddingLeft: '2.5em',
      paddingRight: '2.5em'
    }
  };
};
/**
  * The `<Button>` component allows users to take actions, by tapping or
  * clicking a button.
  *
  * ```js
  * import { Button } from '@theconversation/ui'
  *
  * <Button onClick={alert('click')}>
  *   Click Me!
  * </Button>
  * ```
  */


var Button = function Button(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      colour = _ref.colour,
      prominent = _ref.prominent,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, ["classes", "children", "colour", "prominent", "className"]);

  var muiClasses = {
    root: classes.root
  };
  var joinedClassNames = classNames(className, _defineProperty({}, classes.prominent, prominent));
  return React.createElement(MaterialButton, _extends({
    classes: muiClasses,
    color: colour,
    className: joinedClassNames
  }, other), children);
};

Button.propTypes = {
  /**
   * The content of the button.
   */
  children: PropTypes.node.isRequired,

  /**
   * Overrides the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * The colour of the button.
   *
   * The `primary` buttons (e.g. save, yes, etc.) should have a higher visual
   * emphasis, while `secondary` buttons (e.g. delete, etc.) are given a
   * different emphasis to indicate to the user that they perform an auxiliary
   * action.
   */
  colour: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node. Either a string to use a DOM element
  or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),

  /**
   * A boolean value indicating whether the button is disabled.
   */
  disabled: PropTypes.bool,

  /**
   * A boolean value indicating whether the button should take up the full
   * width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * If true, the button will have slightly more padding around the text,
   * making it a little bit larger than usual.
   */
  prominent: PropTypes.bool,

  /**
   * The URL to link to when the button is clicked. If defined, an `<a>`
   * element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The callback function called when the button is clicked.
   */
  onClick: PropTypes.func,

  /**
   * The size of the button.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The variant of the button.
   */
  variant: PropTypes.oneOf(['text', 'outlined', 'contained'])
};
Button.defaultProps = {
  colour: 'default',
  disabled: false,
  fullWidth: false,
  prominent: false,
  size: 'medium',
  variant: 'contained'
};
export default withStyles(styles)(Button);